import { View, PLATFORM_OVERLAY_SMALL } from "@gaming/srvg-classes-core";
import { AllGroupTablesView } from "./AllGroupTablesView";
import { CuprosterWidget } from "../../widgets/View/VfWidget/CuprosterWidget";
import { RosterWidget } from "../../widgets/View/VfWidget/RosterWidget";


export class GroupAndRosterView extends View {

    allGroupTablesView: AllGroupTablesView;
    cuprosterWidget: CuprosterWidget;

    constructor( options ) {
        options = options || {};
        super( options );

        this.allGroupTablesView = this.addSubView( new AllGroupTablesView( { selector: '#allGroupTablesView' } ) );
        this.cuprosterWidget = null;

        if( srvg.widgets.enabled  && srvg.widgets.widgets['cuproster'].enabled ) {
            // Cuproster widget, if it is enabled in configuration file (srvg.php), show it in overlay
            if(srvg.widgets.widgets['cuproster'].enabled){
                this.cuprosterWidget = this.addSubView(new CuprosterWidget({
                    selector: '#post_group_overlay .tournamentroster',
                    platform: PLATFORM_OVERLAY_SMALL,
                    showTeamAbbr: false,
                    widgetGroup: 'VF'
                }));
            }
        } else if ( srvg.widgets.enabled && srvg.widgets.widgets['roster'].enabled){
            // Cuproster widget, if it is enabled in configuration file (srvg.php), show it in overlay
            this.cuprosterWidget = this.addSubView(new RosterWidget({
                selector: '#post_group_overlay .tournamentroster',
                platform: PLATFORM_OVERLAY_SMALL,
                showTeamAbbr: false,
                widgetGroup: 'VF'
            }));
        }
    }
}